import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/laplace/cdf';
import __var_2__ from '@stdlib/stats/base/dists/laplace/ctor';
import __var_3__ from '@stdlib/stats/base/dists/laplace/entropy';
import __var_4__ from '@stdlib/stats/base/dists/laplace/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/laplace/logcdf';
import __var_6__ from '@stdlib/stats/base/dists/laplace/logpdf';
import __var_7__ from '@stdlib/stats/base/dists/laplace/mean';
import __var_8__ from '@stdlib/stats/base/dists/laplace/median';
import __var_9__ from '@stdlib/stats/base/dists/laplace/mgf';
import __var_10__ from '@stdlib/stats/base/dists/laplace/mode';
import __var_11__ from '@stdlib/stats/base/dists/laplace/pdf';
import __var_12__ from '@stdlib/stats/base/dists/laplace/quantile';
import __var_13__ from '@stdlib/stats/base/dists/laplace/skewness';
import __var_14__ from '@stdlib/stats/base/dists/laplace/stdev';
import __var_15__ from '@stdlib/stats/base/dists/laplace/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace laplace
*/
var laplace = {};

/**
* @name cdf
* @memberof laplace
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/laplace/cdf}
*/
setReadOnly( laplace, 'cdf', __var_1__);

/**
* @name Laplace
* @memberof laplace
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/laplace/ctor}
*/
setReadOnly( laplace, 'Laplace', __var_2__);

/**
* @name entropy
* @memberof laplace
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/laplace/entropy}
*/
setReadOnly( laplace, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof laplace
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/laplace/kurtosis}
*/
setReadOnly( laplace, 'kurtosis', __var_4__);

/**
* @name logcdf
* @memberof laplace
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/laplace/logcdf}
*/
setReadOnly( laplace, 'logcdf', __var_5__);

/**
* @name logpdf
* @memberof laplace
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/laplace/logpdf}
*/
setReadOnly( laplace, 'logpdf', __var_6__);

/**
* @name mean
* @memberof laplace
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/laplace/mean}
*/
setReadOnly( laplace, 'mean', __var_7__);

/**
* @name median
* @memberof laplace
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/laplace/median}
*/
setReadOnly( laplace, 'median', __var_8__);

/**
* @name mgf
* @memberof laplace
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/laplace/mgf}
*/
setReadOnly( laplace, 'mgf', __var_9__);

/**
* @name mode
* @memberof laplace
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/laplace/mode}
*/
setReadOnly( laplace, 'mode', __var_10__);

/**
* @name pdf
* @memberof laplace
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/laplace/pdf}
*/
setReadOnly( laplace, 'pdf', __var_11__);

/**
* @name quantile
* @memberof laplace
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/laplace/quantile}
*/
setReadOnly( laplace, 'quantile', __var_12__);

/**
* @name skewness
* @memberof laplace
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/laplace/skewness}
*/
setReadOnly( laplace, 'skewness', __var_13__);

/**
* @name stdev
* @memberof laplace
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/laplace/stdev}
*/
setReadOnly( laplace, 'stdev', __var_14__);

/**
* @name variance
* @memberof laplace
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/laplace/variance}
*/
setReadOnly( laplace, 'variance', __var_15__);


// EXPORTS //
export default laplace;

export { __var_1__ as cdf, __var_2__ as Laplace, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as logcdf, __var_6__ as logpdf, __var_7__ as mean, __var_8__ as median, __var_9__ as mgf, __var_10__ as mode, __var_11__ as pdf, __var_12__ as quantile, __var_13__ as skewness, __var_14__ as stdev, __var_15__ as variance};